import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translations
import noCommon from './locales/no/common.json';
import enCommon from './locales/en/common.json';

export const defaultNS = 'common';
export const resources = {
  no: {
    common: noCommon,
  },
  en: {
    common: enCommon,
  },
} as const;

// Update HTML lang attribute when language changes
const updateDocumentLanguage = (lang: string) => {
  document.documentElement.lang = lang;
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    defaultNS,
    fallbackLng: 'no',
    supportedLngs: ['no', 'en'],

    interpolation: {
      escapeValue: false, // React already escapes
    },

    detection: {
      // Order of language detection
      order: ['localStorage', 'navigator'],
      // Cache user language preference
      caches: ['localStorage'],
      // Key to use in localStorage
      lookupLocalStorage: 'i18nextLng',
    },

    react: {
      useSuspense: false, // Disable suspense to avoid loading states
    },
  });

// Set initial document language
updateDocumentLanguage(i18n.language);

// Listen for language changes and update HTML lang attribute
i18n.on('languageChanged', (lng) => {
  updateDocumentLanguage(lng);
});

export default i18n;
